import { LoadingOutlined } from "@ant-design/icons";
import { Space, Spin, Typography, theme } from "antd";

const { Text } = Typography;

interface LoadingProps {
  tip?: string;
  fullScreen?: boolean;
}

export const Loading = ({
  tip = "Đang tải dữ liệu...",
  fullScreen = false,
}: LoadingProps) => {
  const { token } = theme.useToken();

  const content = (
    <Space direction="vertical" align="center" size="small">
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: 28, color: token.colorPrimary }}
            spin
          />
        }
      />
      <Text type="secondary">{tip}</Text>
    </Space>
  );

  if (fullScreen) {
    return <div className="state-shell state-shell--fullscreen">{content}</div>;
  }

  return <div className="state-shell">{content}</div>;
};
